module.exports = __webpack_public_path__ + "assets/img/btn-back-f7f165c5.png";